import * as React from 'react';
import request from '@/server/request';
import config from '@/server/config';
import './scss/form.scss';
import UploadImg from '@/pages/components/uploadImg';
import Dialog from '@/pages/components/dialog';
import Tips from '@/pages/components/tips/index'
import alert from '@/pages/components/common/alert';
import { PickerBox } from '@/pages/components/picker';

import store from '@/redux/index';
import * as confirmStore from '@/redux/ui/confirm';
import ActionSheet from '@/pages/components/common/ui/actionsheet';

const Toast = require('react-toast-mobile')

interface initProps {
    history: any,
}

class RealnameAuth extends React.Component < initProps, any > {
    constructor(props: any) {
        super(props);
        this.state = {
            visiblity: false,
            dialogVisiblity: false,
            status: '0', // 个人认证状态
            refuseReason: '', // 不通过原因
            form: {
                trueName: '',
                company: '',
                dept: '',
                companyType: '',
                duty: '',
                businessCard: '',
            },
            componentList: [], // 企业列表
            companyId: '', // 企业id
            isSubmiting: false, // 是否提交
            // 企业分类
            componentsTypeData: {
                displayValue(item: any) {
                    return item.name;
                },
                list: [],
            },
            ComponentsDeptData: {
                displayValue(item: any) {
                    return item.name;
                },
                list: [],
            },
            returnUrl: '',
            fillCardData: {},
            email: '',
            isActivity: ''
        }
    }

    componentDidMount() {
        let returnUrl = this.GetQueryString('returnUrl');
        returnUrl = returnUrl ? decodeURIComponent(returnUrl) : '';

        this.initData();
        this.getComponentsType();
        this.getComponentsDept();

        const froms = this.GetQueryString('from');
        this.setState({
            froms: froms === 'register' ? true : false,
            returnUrl,
            isActivity: this.GetQueryString('type')
        })
    }

    private GetQueryString(name: any) {
        var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
        var r = window.location.search.substr(1).match(reg);
        if (r != null) return unescape(r[2]);
        return null;
    }

    render() {
        return (
            <div className="gray-bg">
				<Tips 
					visiblity = {this.state.visiblity}
					titleText={this.getStatusText(this.state.status).title} 
					promptText={this.getStatusText(this.state.status).subTitle}  
					confirmFn={() => this.setState({visiblity: false}) } />

				<Dialog visiblity={this.state.dialogVisiblity}>
					<div className="certified">
						<p className="certified-title">系统已存在认证企业如下</p>
						<div className="form-radio-group">
							{
								this.state.componentList && this.state.componentList.map((v: any, k:any) => {
									return (
										<div className ="radio-item" key={k}>
											<div className="radio-box">
												<input 
													type="radio" 
													name="radio"   
													className="radio" 
													id={`radio${k}`} 
													onChange={(e:any) => { 
														if(e.target.checked) { 
															this.setState({
																companyId: v.companyId,
															})
														}  
													}} />
												<span className="radio-icon"></span>
											</div>
											<label className="radio-text" htmlFor={`radio${k}`}>{v.msg}<span className="gray">{v.manager}</span></label>
										</div>
									)
								})
							}
						</div>
						<p className="prompt">是否申请加入所选企业?</p>
						<div className="button-box">
							<button className="btn sucess" onClick={() => this.joinComponent()}>申请加入企业</button>
							<button className="btn" onClick={() => this.onlyAuth() }>不加入，只做认证</button>
						</div>
					</div>
				</Dialog>


				<div className="default-form">
					{
						this.state.isActivity === '2024' ?
						<div className="form-input-warrper">
							<label className="label"><span className="red">*</span>电子邮箱</label>
							<input 
								type="text"
								placeholder="请输入电子邮箱"
								className="text-right"
								value={this.state.email	}
								onChange={ (e:any) => this.setState({email: e.target.value}) } />
						</div>
						: <div className="form-upload-warrper">
							<label className="label">个人名片</label>
							<div className="form-upload">
								<UploadImg disabled={this.state.status === '3' ? true : false} sucess={(data: any, path: string) => this.dealCardUploadHandle(data, path)}  id={this.state.form.businessCard} />
							</div>
						</div>
					}
					<div className="form-input-warrper">
						<label className="label"><span className="red">*</span>公司名称</label>
						<input 
							disabled={this.state.status === '3' ? true : false}
							type="text" 
							placeholder="请输入公司名称" 
							className="text-right" 
							value={this.state.form.company	}
							onChange={ (e:any) => this.setForm('company', e.target.value) } />
					</div>
					<div className="form-input-warrper">
						<label className="label"><span className="red">*</span>企业分类</label>
						{/*<input type="text" placeholder="请输入邮箱" className="text-right"  disabled={true} />*/}
						<button
							disabled={this.state.status === '3' ? true : false}
							className="input-select text-right" 
							data-value={this.state.form.companyType.name ? this.state.form.companyType.name : ''} 
							onClick={() => this.showComponentsType() }>
							{ this.state.form.companyType.name ? this.state.form.companyType.name : '请输入企业类型' }
						</button>
					</div>
					<div className="form-input-warrper">
						<label className="label"><span className="red">*</span>姓名</label>
						<input
							disabled={this.state.status === '3' ? true : false}
							type="text" 
							placeholder="请输入姓名" 
							className="text-right" 
							value={this.state.form.trueName	}  
							onChange={ (e:any) => this.setForm('trueName', e.target.value) } />
					</div>
					<div className="form-input-warrper">
						<label className="label"><span className="red">*</span>所在部门</label>
						<button
							disabled={this.state.status === '3' ? true : false}
							className="input-select text-right" 
							data-value={this.state.form.dept.name ? this.state.form.dept.name : ''} 
							onClick={() => this.showComponentsDept() }>
							{ this.state.form.dept.name ? this.state.form.dept.name : '请输入企业部门' }
						</button>
					</div>
					<div className="form-input-warrper">
						<label className="label">职位</label>
						<input
							disabled={this.state.status === '3' ? true : false}
							type="text" 
							placeholder="请输入职位" 
							className="text-right" 
							value={this.state.form.duty	}  
							onChange={ (e:any) => this.setForm('duty', e.target.value) }/>
					</div>
				</div>
				{
					this.state.isActivity === '2024' ?
					<div className="form-btn-warrrper">
						<button className="form-btn" onClick={() =>  this.submitForm()}>提交</button>
					</div>
					 : 
					<div className="form-btn-warrrper">
						{
							this.state.status === '0' ? <button className="form-btn" onClick={() =>  this.submitForm()}>申请认证</button>: ''
						}
						{
							this.state.status === '0' ? <button className="form-btn white" onClick={() =>  this.removes()}>取消</button> : ''
						}
						{
							this.state.status === '2' ? <button className="form-btn" onClick={() =>  this.submitForm()}>重新认证</button>: ''
						}
						{
							this.state.status === '1' ? <button className="form-btn" onClick={() =>  this.submitForm()}>更新信息</button>: ''
						}
					</div>
				}
				<ActionSheet />
			</div>
        )
    }

    private removes() {
        if (this.state.returnUrl) {
            window.location.href = config.WAPAPI + 'buy/list.html';
            return;
        }
        this.props.history.push('/userInfo')
    }

    // 表单赋值
    private setForm(name ? : string, val ? : any) {
        if (!name) {
            return;
        }
        this.state.form[name] = val;
        this.setState({
            form: {
                ...this.state.form,
            }
        })
    }

    // 检测表单
    private checkForm() {
        const companyNameReg = /[。\/？》《\>\<\~\!\@\#\%\$\%\^\&\*]/
        const companyNameHasNumReg = /\d/
        const compnayNameHasEnglish = /[a-zA-Z]/
        const companyNameChinese = /[\u4e00-\u9fa5]/
        const companyNameHasBlank = /[\r\s]/
        const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        // if (this.state.form.businessCard === '') {
        // 	return alert.open({ promptText: '请上传名片'})
        // }
        if (this.state.isActivity === '2024') {
            if (this.state.email.trim() === '') {
                return alert.open({
                    promptText: '请输入电子邮箱'
                })
            } else if (!emailRegex.test(this.state.email.trim())) {
                return alert.open({
                    promptText: '邮箱格式错误'
                })
            }
        }
        if (!this.state.form.company || this.state.form.company.trim() === '') {
            return alert.open({
                promptText: '请输入公司名称'
            });
        }
        if (companyNameReg.test(this.state.form.company)) {
            return alert.open({
                promptText: '企业名称存在特殊字符，请重新输入！'
            });
        }
        if (companyNameChinese.test(this.state.form.company)) {
            if (!compnayNameHasEnglish.test(this.state.form.company) && companyNameHasBlank.test(this.state.form.company)) {
                return alert.open({
                    promptText: '企业名称存在空格，请重新输入'
                });
            }
        }
        if (companyNameHasNumReg.test(this.state.form.company)) {
            return alert.open({
                promptText: '企业名称不能存在数字，请重新输入！'
            });
        }
        if (this.state.form.companyType.toString().replace(/\s/gi, '') === '') {
            alert.open({
                promptText: '请输入企业类型',
            })
            return;
        }
        if (this.state.form.trueName.replace(/\s/gi, '') === '') {
            alert.open({
                promptText: '请输入姓名',
            })
            return;
        }

        if (this.state.form.dept.toString().replace(/\s/gi, '') === '') {
            alert.open({
                promptText: '请输入所在部门',
            })
            return;
        }

        return true
    }

    // 提交表单
    private async submitForm() {
        const that = this;

        if (!this.checkForm()) {
            return;
        }

        // 防止重复提交
        if (this.state.isSubmiting) {
            return;
        }

        this.setState({
            isSubmiting: true
        })

        const r = await request({
            method: "post",
            url: `${config.CE}member/auth/personal/submit`,
            data: {
                ...this.state.form,
                companyType: this.state.form.companyType.value ? this.state.form.companyType.value : '',
                dept: this.state.form.dept.value ? this.state.form.dept.value : '',
                ocrPhones: this.state.fillCardData.phone || [],
                email: this.state.email,
                activityType: this.state.isActivity === '2024' ? 2 : ''
            }
        });

        this.setState({
            isSubmiting: false,
        })

        // 企业相同
        if (r.code === 200) {
            // this.props.history.push('/auth/step1')
            this.setState({
                componentList: r.obj,
                dialogVisiblity: true,
            })

            return;
        }

        if (r.code !== 1) {
            alert.open({
                promptText: r.msg,
            })
        } else {
            this.setState({
                form: {
                    trueName: '',
                    company: '',
                    dept: '',
                    companyType: '',
                    duty: '',
                    businessCard: '',
                }
            }, () => {
                alert.open({
                    promptText: '提交成功',
                    callback: () => {
                        //that.props.history.push('/userInfo')
                        if (this.state.returnUrl) {
                            window.location.href = this.state.returnUrl;
                        } else {
                            that.props.history.push('/userInfo')
                        }
                    }
                })


            })
        }
    }

    // 加入企业
    private async joinComponent() {
        const that = this;

        if (String(this.state.companyId).replace(/\s/gi, '') === '') {
            alert.open({
                promptText: '请选择认证企业',
            })
            return;
        }
        const r = await request({
            method: "post",
            url: `${config.CE}member/auth/company/join`,
            data: {
                companyId: this.state.companyId,
            }
        });

        if (r.code !== 1) {
            alert.open({
                promptText: r.msg,
            })
        } else {
            this.setState({
                companyId: '',
                dialogVisiblity: false,
            }, () => {
                alert.open({
                    promptText: '加入企业成功',
                    callback: () => {

                        if (that.state.returnUrl) {
                            window.location.href = that.state.returnUrl;
                        } else {
                            that.props.history.push('/auth/status')
                        }
                    }
                })

            })
        }
    }

    // 返回初始化数据
    private async initData() {
        const r = await request({
            method: "get",
            url: `${config.CE}/member/info`,
        });

        if (r.code !== 1) {
            alert.open({
                promptText: r.msg,
            })
        } else {
            const data = r.obj ? r.obj : '';
            if (!data) {
                return;
            }
            this.setState({
                visiblity: this.state.isActivity !== '2024',
                status: data.personalAuthenticationStatus ? data.personalAuthenticationStatus : '',
                refuseReason: data.refuseReason ? data.refuseReason : '',
                form: {
                    trueName: data.trueName ? data.trueName : '',
                    company: data.company ? data.company : '',
                    dept: data.dept ? { name: data.deptName, value: data.dept } : '',
                    companyType: data.companyType ? { name: data.companyTypeValue, value: data.companyType } : '',
                    duty: data.duty ? data.duty : '',
                    businessCard: data.businessCard ? data.businessCard : '',
                },
                email: data.email || ''
            })
        }
    }

    private getStatusText(data: any) {
        switch (data) {
            case '0':
                return {
                    title: '未认证',
                    subTitle: '请填写以下信息完成认证',
                }
            case '1':
                return {
                    title: '已认证',
                    subTitle: '',
                }
                break;
            case '2':
                return {
                    title: '审核不通过',
                    subTitle: this.state.refuseReason,
                }
                break;
            case '3':
                return {
                    title: '待审核',
                    subTitle: '请耐心等待审核结果，如果有需要欢迎随时致电平台客服电话4009-300-360',
                }
                break;
            default:
                return {
                    title: '',
                    subTitle: '',
                }
        }
    }

    // 个人分类
    private async getComponentsType() {
        // 获取数据
        const r = await request({
            method: "get",
            url: `${config.CE}member/info/companyType`,
            data: {
                flag: 1,
            }
        });
        if (r.code !== 1) {
            alert.open({
                promptText: r.msg,
            })
            return;
        }
        this.setState({
            componentsTypeData: {
                ...this.state.componentsTypeData,
                list: r.obj
            }
        })
    }

    // 个人部门
    private async getComponentsDept() {
        // 获取数据
        const r = await request({
            method: "get",
            url: `${config.CE}member/info/dept`,
        });
        if (r.code !== 1) {
            alert.open({
                promptText: r.msg,
            })
            return;
        }
        this.setState({
            ComponentsDeptData: {
                ...this.state.ComponentsDeptData,
                list: r.obj
            }
        })
    }

    // 显示个人分类面板
    private showComponentsType() {
        const that = this;
        // 显示弹框
        (PickerBox as any).open({
            data: [{
                ...that.state.componentsTypeData
            }],
            valueLable: 'id',

            // 成功回调
            onConfrim: (data: any) => {
                that.setState({
                    form: {
                        ...this.state.form,
                        companyType: {
                            name: data.name,
                            value: data.value,
                        },
                    }
                })
            }
        })
    }

    // 显示个人部门面板
    private showComponentsDept() {
        const that = this;
        // 显示弹框
        (PickerBox as any).open({
            data: [{
                ...that.state.ComponentsDeptData
            }],
            valueLable: 'id',

            // 成功回调
            onConfrim: (data: any) => {
                that.setState({
                    form: {
                        ...this.state.form,
                        dept: {
                            name: data.name,
                            value: data.value,
                        },
                    }
                })
            }
        })
    }
    // 不加入，只做认证
    private onlyAuth() {
        this.setState({ dialogVisiblity: false, companyId: '' });
        const that = this;
        alert.open({
            promptText: '保存成功',
            callback: () => {
                that.state.returnUrl ? (window as any).location.href = that.state.returnUrl : (that.props as any).history.push('/auth_sucess')
                //that.props.history.push('/userInfo');
            }
        })
    }


    private async dealCardUploadHandle(data: any, path: string) {
        this.setForm('businessCard', data)
        Toast.T.loading('名片分析中...');
        // 获取数据
        const r = await request({
            method: "post",
            url: `${config.COMPONENT_API}openai/card/extract`,
            headers: {
                'Content-Type': 'application/json'
            },
            data: {
                curl: path,
            }
        }, true);
        if (r.code === 1) {
            this.setState({
                fillCardData: r.obj
            }, () => {
                Toast.T.loaded()
                this.showFillCardData()
            })
        } else {
            Toast.T.loaded()
            Toast.T.notify(r.message)
        }
    }

    private showFillCardData() {
        store.dispatch({
            type: confirmStore.types.CONFIRM_SHOW,
            data: {
                text: '<div class="card-fill">个人名片内容自动识别，是否填充？<br/>公司名称：' + this.state.fillCardData.company + '<br/>姓名：' + this.state.fillCardData.trueName + '<br/>职位：' + this.state.fillCardData.duty + '</div>',
                confirm: '填充',
                cancel: '否',
                onConfirm: () => {
                    this.setForm('company', this.state.fillCardData.company)
                    this.setForm('trueName', this.state.fillCardData.trueName)
                    this.setForm('duty', this.state.fillCardData.duty)
                },
                onHide: () => {}
            }
        });
    }
}

export default RealnameAuth;